import { CssBaseline, ThemeProvider } from '@mui/material'
import { SnackbarProvider } from 'notistack'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { AutoAuthWrapper, CustomAuthProvider } from '@/auth'

import App from './App'
import { theme } from './utils/theme'

import './config/i18n'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SnackbarProvider
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <CustomAuthProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AutoAuthWrapper>
            <App />
          </AutoAuthWrapper>
        </ThemeProvider>
      </CustomAuthProvider>
    </SnackbarProvider>
  </React.StrictMode>,
)
